const updateTypes = {
  id: "updateTypes",
  label: "Update Types",
  endpoint: "update_types",
  columnConfig: [
    {
      field: "name",
      headerName: "Update Type",
      width: 250,
      description: "Update Type",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default updateTypes;
